import React from "react"
import { ThemeProvider } from 'styled-components'
import styled from 'styled-components'

import PageAttributes from '@utils/PageAttributes'
import GlobalStyle from '@styles/Global'
import theme from '@styles/Theme'

const Wrapper = styled.div`
  height: ${props => props.windowHeight}px;
  position: relative;
`

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowHeight: 'auto'
    }
    this.resize = this.resize.bind(this)
  }

  componentDidMount() {
    // initial calculation
    this.resize()

    // bind to resize
    window.addEventListener('resize', ()=> {
      this.resize()
    })

  }

  resize() {
    this.setState({
      windowHeight: window.innerHeight
    })
  }

  render() {
    return (
      <React.Fragment>
        <PageAttributes/>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
          <Wrapper windowHeight={this.state.windowHeight}>
            {this.props.children}
          </Wrapper>
        </ThemeProvider>
      </React.Fragment>
    )
  }
}

export default Layout

// export default ({ children }) => (

// )